var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBrasil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H21V18.0001H3V6Z",
    fill: "#029F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.9353L17.5161 11.9998L12 16.0644L6.48382 11.9998L12 7.9353Z",
    fill: "#FFE001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3223C13.2827 14.3223 14.3226 13.2825 14.3226 11.9998C14.3226 10.7171 13.2827 9.67725 12 9.67725C10.7173 9.67725 9.67749 10.7171 9.67749 11.9998C9.67749 13.2825 10.7173 14.3223 12 14.3223Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8387 11.8547C10.4453 11.8544 10.054 11.9135 9.67818 12.0301C9.69443 13.2988 10.7275 14.3224 12 14.3224C12.7869 14.3224 13.4819 13.9307 13.9019 13.3321C13.1833 12.4323 12.0773 11.8547 10.8387 11.8547V11.8547ZM14.2795 12.4448C14.3075 12.3007 14.3226 12.1521 14.3226 11.9998C14.3226 10.7171 13.2828 9.67725 12 9.67725C11.0429 9.67725 10.2213 10.2564 9.86569 11.0831C10.1858 11.0169 10.5118 10.9836 10.8387 10.9837C12.1878 10.9837 13.4081 11.5445 14.2795 12.4448Z",
    fill: "#002279"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrasil);
export default __webpack_public_path__ + "static/media/flag-brasil.d119c44af751619e3f97b18b1d2d3778.svg";
export { ForwardRef as ReactComponent };